import React from 'react';
import { useTranslation } from 'react-i18next';
import { useEvaluationStore, useCurrentStep } from '../../store/evaluationStore';

export const Stepper: React.FC = () => {
  const { t } = useTranslation();
  const currentStep = useCurrentStep();
  const { setCurrentStep, products, criteria, evaluationPositions, getGrades } = useEvaluationStore();    const steps = [
    { id: 1, title: t('steps.productRegistration.title') },
    { id: 2, title: t('steps.criteriaExtraction.title') },
    { id: 3, title: t('steps.comparison.title') },
    { id: 4, title: t('steps.gradeAssignment.title') },
    { id: 5, title: t('steps.rubricGeneration.title') },
    { id: 6, title: t('steps.quickEvaluation.title') },
    { id: 7, title: t('steps.reportGeneration.title') }
  ];  // ステップの完了状態を判定
  const getStepStatus = (stepId: number) => {
    if (stepId < currentStep) return 'completed';
    if (stepId === currentStep) return 'current';
    
    // 次のステップに進む条件をチェック
    switch (stepId) {
      case 2:
        return products.length > 0 ? 'available' : 'pending';
      case 3:
        return products.length > 0 && criteria.length > 0 ? 'available' : 'pending';
      case 4:
        return products.length > 0 && criteria.length > 0 ? 'available' : 'pending';
      case 5:
        return products.length > 0 && criteria.length > 0 ? 'available' : 'pending';
      case 6:
        // ルーブリック生成が完了していればクイック評価可能
        return products.length > 0 && criteria.length > 0 ? 'available' : 'pending';
      case 7:
        // 評価が完了していれば成績表出力可能
        return products.length > 0 && criteria.length > 0 ? 'available' : 'pending';
      default:
        return 'pending';
    }
  };

  const handleStepClick = (stepId: number) => {
    const status = getStepStatus(stepId);
    if (status === 'available' || status === 'completed' || status === 'current') {
      setCurrentStep(stepId);    }
  };

  return (
    <nav className="stepper" aria-label={t('steps.process.ariaLabel')}>
      <ol className="stepper__list">
        {steps.map((step, index) => {
          const status = getStepStatus(step.id);
          return (
            <li 
              key={step.id}
              className={`stepper__item stepper__item--${status}`}
            >              <button
                className="stepper__button"
                onClick={() => handleStepClick(step.id)}
                aria-current={step.id === currentStep ? 'step' : undefined}
                disabled={status === 'pending'}
              >
                <span className="stepper__number">{step.id}</span>
                <span className="stepper__text">
                  <span className="stepper__title">{step.title}</span>
                </span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};